import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';
import { FormFieldLine } from '../../../../../components/form-field-line/form-field-line';
import { LABEL_POSITIONS, Toggle } from '../../../../../components/inputs/toggle/toggle';
import TableRow from '../../../../../components/table/components/table-row/table-row';
import Table from '../../../../../components/table/table';
import { FEATURES } from '../../../../../models/Plan';
import { EXCHANGE_TYPES, exchangeTypesViewList } from '../../../../../models/User';
import currentPortalStore from '../../../../../stores/current-portal-store';
import Translation from '../../../../../translation/translation';
import './switch-to-exchange.scss';
import ResolveCapability from "../../../../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";

interface ISwitchToExchangeProps {
    isEnabled?: boolean;
    exchangeTypes?: string;
    onToggle: () => void;
    onExchangeTypeChange: (exchangeType: string) => void;
}

const SwitchToExchange = ({ isEnabled, exchangeTypes, onToggle, onExchangeTypeChange }: ISwitchToExchangeProps) => {
    const exchangeTypesArr = exchangeTypes?.split(',') ?? [];

    const isProductExchangeFeatureAllowed = currentPortalStore.isFeatureAllowed(FEATURES.PRODUCT_EXCHANGE);
	const isAnyToAnyExchangesFeatureAllowed = currentPortalStore.isFeatureAllowed(FEATURES.PRODUCT_EXCHANGE);

    return (
		<ResolveCapability capability={PROFILE_CAPABILITIES.SWITCH_TO_EXCHANGE}>
			{({ isSupported, isFeatureEnabled, isSwitchToProductExchangeSupported, isSwitchToVariantExchangeSupported }) =>
				!isSupported || !isAnyToAnyExchangesFeatureAllowed && (
					<div className='return-reason-switch-to-exchange'>
						<FormFieldLine
							label='Offer to Switch to Exchange'
							tooltip={!isFeatureEnabled ? <Translation Font={FontBody2} color={FONT_COLOR.NEUTRAL_WHITE} translationKey='FEATURE_IS_NOT_INCLUDED' /> : ''}
						>
							<Toggle
								checked={isEnabled}
								label=''
								labelPosition={LABEL_POSITIONS.LEFT}
								onChange={onToggle}
								disabled={!isFeatureEnabled}
							/>
						</FormFieldLine>
						{!isFeatureEnabled && !!isEnabled && (
							<div className='switch-to-exchange-types'>
								<FormFieldLine
									label='Exchange types'
									note={<Translation Font={FontBody2} color={FONT_COLOR.NEUTRAL3} translationKey='CHOOSE_THE_EXCHANGE_OPTION' />}
									required
								>
									<Table
										columns={[
											{
												content: 'Exchange type',
												width: {
													value: 1,
													type: 'fr'
												}
											},
											{
												content: '',
												width: {
													value: 1,
													type: 'fr'
												}
											},
										]}
										totalResultsTitle='Switch to Exchange Setting'
									>
										{exchangeTypesViewList().map(exchangeType => (
											<TableRow
												key={exchangeType.value}
												cells={[
													exchangeType.label,
													<Toggle
														checked={exchangeTypesArr.includes(exchangeType.value)}
														onChange={() => onExchangeTypeChange(exchangeType.value)}
														label=''
														disabled={(
															(
																exchangeType.value === EXCHANGE_TYPES.PRODUCT_EXCHANGE &&
																(!isSwitchToProductExchangeSupported || !isProductExchangeFeatureAllowed)
															) || (
																exchangeType.value === EXCHANGE_TYPES.VARIANT_EXCHANGE &&
																!isSwitchToVariantExchangeSupported
															)
														)}
													/>
												]}
											/>
										))}
										{!isProductExchangeFeatureAllowed && (
											<Translation Font={FontBody2} color={FONT_COLOR.NEUTRAL3} translationKey='MANAGE_ADDONS' />
										)}
									</Table>
								</FormFieldLine>
							</div>
						)}
					</div>
				)
			}
		</ResolveCapability>
    );
};

export default SwitchToExchange;
